import { CookieSettingsButton } from '@/components/CookieSettingsButton';
import { company } from '@/config/company';
import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export function SmallFooter({
  showTrustLinks = false,
  openLinksInNewTab = false,
}: {
  showTrustLinks?: boolean;
  openLinksInNewTab?: boolean;
}) {
  const newTabProps = openLinksInNewTab
    ? { target: '_blank' as const, rel: 'noopener noreferrer' }
    : {};

  return (
    <footer className="py-4 border-t">
      <div className="container mx-auto">
        <div className="mb-3 flex justify-center text-center">
          <p className="flex items-center justify-center gap-1 text-xs text-gray-700 sm:text-sm">
            <Mail className="h-4 w-4 text-blue-600" />
            <a
              href="https://bookstera.com/contact"
              className="underline transition-colors hover:text-blue-800"
              {...newTabProps}
            >
              Need Help? Contact Us
            </a>
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
          {showTrustLinks && (
            <>
              <Link to={company.urls.about} {...newTabProps} className="transition-colors hover:text-primary">
                About / Founder
              </Link>
              <Link to={company.urls.successStories} {...newTabProps} className="transition-colors hover:text-primary">
                Success Stories
              </Link>
              <Link to={company.urls.reviews} {...newTabProps} className="transition-colors hover:text-primary">
                Customer Reviews
              </Link>
              <Link to={company.urls.refundPolicy} {...newTabProps} className="transition-colors hover:text-primary">
                Refund Policy
              </Link>
            </>
          )}
          <Link
            to="/privacy-policy"
            {...newTabProps}
            className="hover:text-primary transition-colors"
          >
            Privacy Policy
          </Link>
          <Link to="/terms" {...newTabProps} className="hover:text-primary transition-colors">
            Terms of Service
          </Link>
          <Link to="/imprint" {...newTabProps} className="hover:text-primary transition-colors">
            Imprint
          </Link>
          <CookieSettingsButton className="h-auto p-0 text-sm font-normal text-muted-foreground hover:text-primary" />
        </div>

        <div className="mt-3 space-y-1 text-center text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Bookstera®. All rights reserved.</p>
          {showTrustLinks ? (
            <p className="text-2xs">
              Operated by {company.legalName} · {company.companyNumber} · {company.city}, {company.country} · Founder:{' '}
              <Link className="underline transition-colors hover:text-foreground" to={company.urls.about} {...newTabProps}>
                {company.founder}
              </Link>
            </p>
          ) : (
            <p className="text-2xs">Bookstera® is a registered trademark of Bookstera FlexCo.</p>
          )}
        </div>

        {!showTrustLinks && (
          <div className="flex justify-center mt-2 text-xs text-muted-foreground items-center space-x-1">
            <span>Made with</span>
            <svg
              className="inline w-4 h-4 text-red-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
            >
              <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" />
            </svg>
            <span>in Vienna, Austria</span>
          </div>
        )}
      </div>
    </footer>
  );
}
